import React, { forwardRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import TenableWebappMappingForm from './TenableWebappMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function TenableWebappCredentialsForm(props, ref) {
    const fields = [{
        name: "accessKey",
        label: "Access Key",
        required: true
    }, {
        name: "secretKey",
        label: "Secret Key",
        type: FieldTypes.PASSWORD,
        required: true
    }]

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={TenableWebappMappingForm}
        />
    )
}

export default forwardRef(TenableWebappCredentialsForm);